/* eslint-disable */ import { memoEval, priceComponent, sceneEntityRemoteMaterialOverrideComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const boardShortsComponents = [
    attachComponent.withComponent(priceComponent, 'default', true).withEntity('BoardShorts').attach(memoEval((self)=>[
            self.$price
        ], ($price)=>({
            currency: 'USD',
            price: $price
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'shorts', true).withEntity('BoardShorts').attach(memoEval(()=>[], ()=>({
            fileUrl: 'models/board-shorts.glb',
            objectName: 'BoardShorts',
            dimensionUnit: 'm'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'stitches', true).withEntity('BoardShorts').attach(memoEval(()=>[], ()=>({
            fileUrl: 'models/board-shorts.glb',
            objectName: 'BoardShortsStitches',
            dimensionUnit: 'm'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'linerMesh', true).withEntity('BoardShorts').withGradualFilter({
        active: (self)=>self.$isMeshLiner
    }).attach(memoEval(()=>[], ()=>({
            fileUrl: 'models/board-shorts.glb',
            objectName: 'BoardShortsLinerMesh',
            dimensionUnit: 'm'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'linerCompression', true).withEntity('BoardShorts').withGradualFilter({
        active: (self)=>self.$isCompressionLiner
    }).attach(memoEval(()=>[], ()=>({
            fileUrl: 'models/board-shorts.glb',
            objectName: 'BoardShortsLinerCompression',
            dimensionUnit: 'm'
        }))),
    attachComponent.withComponent(sceneEntityRemoteMaterialOverrideComponent, 'leftLeg', true).withEntity('BoardShorts').attach(memoEval((self)=>[
            self.$leftLegMaterial
        ], ($leftLegMaterial)=>$leftLegMaterial)),
    attachComponent.withComponent(sceneEntityRemoteMaterialOverrideComponent, 'rightLeg', true).withEntity('BoardShorts').attach(memoEval((self)=>[
            self.$rightLegMaterial
        ], ($rightLegMaterial)=>$rightLegMaterial)),
    attachComponent.withComponent(sceneEntityRemoteMaterialOverrideComponent, 'leftThighBand', true).withEntity('BoardShorts').attach(memoEval((self)=>[
            self.$leftThighBandMaterial
        ], ($leftThighBandMaterial)=>$leftThighBandMaterial)),
    attachComponent.withComponent(sceneEntityRemoteMaterialOverrideComponent, 'rightThighBand', true).withEntity('BoardShorts').attach(memoEval((self)=>[
            self.$rightThighBandMaterial
        ], ($rightThighBandMaterial)=>$rightThighBandMaterial)),
    attachComponent.withComponent(sceneEntityRemoteMaterialOverrideComponent, 'waistband', true).withEntity('BoardShorts').attach(memoEval((self)=>[
            self.$waistbandMaterial
        ], ($waistbandMaterial)=>$waistbandMaterial)),
    attachComponent.withComponent(sceneEntityRemoteMaterialOverrideComponent, 'drawstring', true).withEntity('BoardShorts').attach(memoEval((self)=>[
            self.$drawstringMaterialColor
        ], ($drawstringMaterialColor)=>({
            fileUrl: 'models/board-shorts.glb',
            materialName: 'LacesMaterial',
            materialsToOverride: [
                'LacesMaterial'
            ],
            color: $drawstringMaterialColor
        }))),
    attachComponent.withComponent(sceneEntityRemoteMaterialOverrideComponent, 'stitches', true).withEntity('BoardShorts').attach(memoEval((self)=>[
            self.$stitchesMaterialColor
        ], ($stitchesMaterialColor)=>({
            fileUrl: 'models/board-shorts.glb',
            materialName: 'StitchesMaterial',
            materialsToOverride: [
                'StitchesMaterial'
            ],
            color: $stitchesMaterialColor
        })))
];

//# sourceMappingURL=board-shorts.js.map